import React, {FC, useEffect, useState} from 'react';
import {navigate} from 'gatsby-link';
import {Modal} from '../../modal';
import Button from '../../button';
import {closeIcon} from '../../../images/svgIcons';
import {useQuery} from '@apollo/react-hooks';
import {ME} from '../../../graphql/queries';
import './styles.scss';

interface IProps {
  toolName: string;
  setOpen: () => void;
}

const GoToLoginPage: FC<IProps> = ({toolName, setOpen}) => {
  const [user, setUser] = useState<{email?: ''}>({});
  const {data, loading, refetch} = useQuery(ME);
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (data && data.User && data.User.get && !data.User.get.error) {
      setUser(data.User.get);
    }
  }, [data]);
  if (loading) return null;
  return (
    <Modal isOpen={true} modalToggle={() => {}} modalFooter={<></>} className="go-to-login-page">
      <div className="text-center">
        <div className="cursor-pointer text-right close-icon" onClick={setOpen}>
          {closeIcon}
        </div>
        <div className="mb-3">You have used your {toolName} daily allowance for the day.</div>
        <div>
          <strong>
            <span onClick={() => navigate('/registration')} className="hexomatic-color cursor-pointer">
              Sign up
            </span>{' '}
            for Hexomatic account
          </strong>{' '}
          to unlock more {toolName} tasks and get access to 100+ ready made growth hacking automations.
        </div>
        <div className="mt-5 mb-3">
          <Button
            onClick={() =>
              user.email && window
                ? window.location.replace('https://dash.hexomatic.com/dashboard')
                : navigate('/login')
            }
            className="w-md-75"
          >
            Go to {user.email ? 'dashboard' : 'login page'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default GoToLoginPage;
